import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { BREAK_ACTIONS } from '../../../../../utils/constants/breakConstants';
import { StepContentContainer, ModalTitle, OptionsContainer, OptionButton } from '../BreakOptionsModal.styles';

const OptionsStep = ({
  showRestButton,
  showBreakButton,
  isLoading,
  isStartingMealBreak,
  handleBreakActionClick
}) => {
  return (
    <StepContentContainer>
      <ModalTitle variant="h6" component="h2">
        Break Options
      </ModalTitle>

      <OptionsContainer>
        {showRestButton && (
          <OptionButton
            variant="contained"
            onClick={() => handleBreakActionClick(BREAK_ACTIONS.START_REST)}
            fullWidth
            disabled={isLoading || isStartingMealBreak}
          >
            Start rest break
          </OptionButton>
        )}

        {showBreakButton && (
          <OptionButton
            variant="contained"
            onClick={() => handleBreakActionClick(BREAK_ACTIONS.START_MEAL)}
            fullWidth
            disabled={isLoading || isStartingMealBreak}
          >
            {isStartingMealBreak ? (
              <>
                <CircularProgress color="inherit" size={16} />
                Starting meal break...
              </>
            ) : (
              'Start meal break'
            )}
          </OptionButton>
        )}

        <OptionButton
          variant="contained"
          onClick={() => handleBreakActionClick(BREAK_ACTIONS.WAIVE)}
          fullWidth
          disabled={isLoading || isStartingMealBreak}
        >
          Waive break
        </OptionButton>
      </OptionsContainer>
    </StepContentContainer>
  );
};

OptionsStep.propTypes = {
  showRestButton: PropTypes.bool,
  showBreakButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  isStartingMealBreak: PropTypes.bool,
  handleBreakActionClick: PropTypes.func.isRequired,
};

export default OptionsStep;
